import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SQLService } from '../services/sql.service';
import { PopoverController } from '@ionic/angular';
import { JobMenuComponent } from './job-menu/job-menu.component';
@Component({
  selector: 'ng-cheques-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.styl']
})
export class JobsComponent implements OnInit {
  constructor(
    private router: Router,
    public popoverController: PopoverController,
    public sql: SQLService
  ) {
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) this.get_jobs();
    }); 
  }
  count=-1;
  search:string;
  jobs: [];
  showing_popover:boolean;lpevent:any;
  _md(e){this.lpevent=e;}
  async popover(item?) {
    if(this.showing_popover)return;
    this.showing_popover=true;
    this.sql.hapticsImpactMedium();
    var popover = await this.popoverController.create({
      component:JobMenuComponent,
      cssClass: 'popover_container',
      translucent: true,
      componentProps: {enabled: item.enabled},
      event: this.lpevent?this.lpevent:false
    });
    popover.present();
    var { data } = await popover.onWillDismiss();
    if (data && item) {
      this.sql.hapticsImpactLight();
      if(data=='enable')this.enable(item);
      if(data=='disable')this.disable(item);
      if(data=='delete')this.delete(item, false);
    }
    this.showing_popover=false;
    this.lpevent=null;
  }
  get_jobs(event?) {
    this.sql.fetch('Jobs',(e)=>{
      if(e)this.jobs=e;
      this.count=e.length;
      setTimeout(()=>{
        if (event) event.target.complete();
      },1234);
    });
  }
  edit(job, item?) {
    this.router.navigate(['folder','Job',job.job_id]);
    if(item)item.closeSlidingItems();
  }
  end() {this.router.navigate(['folder','Dashboard']);}
  delete(job, item?) {
    if(confirm(this.sql.word.Delete_Job_Confirmation)) {
      this.sql.delete('Jobs','job_id',job.job_id);
      this.get_jobs();
    } else { if(item)item.closeSlidingItems(); }
  }
  enable(job, item?){
    this.sql.set('Jobs','job_id',job.job_id,'enabled',1,(res)=>{
      job.enabled = true;
      if(item)item.closeSlidingItems();
    });
  }
  disable(job, item?){
    this.sql.set('Jobs','job_id',job.job_id,'enabled',0,(res)=>{
      job.enabled = false;
      if(item)item.closeSlidingItems();
    });
  }
  add() {
    this.router.navigate(['folder','Job','New']);
  }
  filter(e) {
    this.search=e.target.value;
  }
  ngOnInit() {
    this.get_jobs();
  }
}